import { Link } from 'react-router-dom'
import { Customer } from '../types'
import { ShieldExclamationIcon, CheckCircleIcon } from '@heroicons/react/24/outline'

// Helper to get initials from a name
const getInitials = (name: string) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
  return initials.slice(0, 2).toUpperCase()
}

// A simple hash function to get a color for the avatar background
const stringToColor = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  const color = `hsl(${hash % 360}, 75%, 60%)`
  return color
}

export default function CustomerCard({ customer }: { customer: Customer }) {
  const { id, name, email, photoURL, isActive, deactivatedAt } = customer

  return (
    <Link to={`/customers/${id}`} className="block">
      <div className={`bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 ease-in-out h-full ${
        isActive === false ? 'border-l-4 border-red-400 bg-red-50' : ''
      }`}>
        <div className="flex items-center space-x-4">
          <div className="flex-shrink-0">
            {photoURL ? (
              <img className="h-12 w-12 rounded-full object-cover" src={photoURL} alt={name} />
            ) : (
              <div
                className="h-12 w-12 rounded-full flex items-center justify-center text-white font-bold text-xl"
                style={{ backgroundColor: stringToColor(name) }}
              >
                {getInitials(name)}
              </div>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-1">
              <p className="text-sm font-bold text-gray-900 truncate">{name}</p>
              
              {/* Account Status Icon */}
              {isActive === false ? (
                <ShieldExclamationIcon className="h-4 w-4 text-red-500 flex-shrink-0" title="Account Deactivated" />
              ) : (
                <CheckCircleIcon className="h-4 w-4 text-green-500 flex-shrink-0" title="Active Account" />
              )}
            </div>
            
            <p className="text-sm text-gray-500 truncate">{email}</p>
            
            {/* Deactivation Date */}
            {deactivatedAt && (
              <p className="text-xs text-red-600 mt-1">
                Deactivated: {new Date(deactivatedAt).toLocaleDateString()}
              </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  )
} 